import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {ProviderEvent} from '../../models/vte';
import {ProviderEventViewService} from '../../services/vte/provider-event-view.service';
import {VteApiService} from '../../services/vte/vte-api.service';
import {ActivityTimelineComponent} from '../../shared/activity-timeline/activity-timeline.component';
import {MetadataPanelComponent, OperationsBackLinkComponent, ProviderEventStatusBadgeComponent} from '../../shared/vte';

@Component({
    selector: 'app-provider-event-detail',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        ActivityTimelineComponent,
        MetadataPanelComponent,
        OperationsBackLinkComponent,
        ProviderEventStatusBadgeComponent,
    ],
    templateUrl: './provider-event-detail.component.html',
    styleUrl: './provider-event-detail.component.css',
})
export class ProviderEventDetailComponent implements OnInit {
    event: ProviderEvent | null = null;
    loading = true;
    backLinkQueryParams: Record<string, string> = {};

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private vteApi: VteApiService,
        public providerEventView: ProviderEventViewService,
    ) {
    }

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((queryParams) => {
            const next: Record<string, string> = {};
            queryParams.keys.forEach((key) => {
                const value = queryParams.get(key);
                if (value) {
                    next[key] = value;
                }
            });
            this.backLinkQueryParams = next;
        });
        this.route.paramMap.subscribe((params) => {
            const eventId = params.get('id');
            if (!eventId) {
                this.router.navigate(['/operations/provider-events']);
                return;
            }
            const providerId = this.route.snapshot.queryParamMap.get('provider_id') || undefined;
            this.loadEvent(eventId, providerId);
        });
    }

    loadEvent(eventId: string, providerId?: string): void {
        this.loading = true;
        this.event = null;
        this.vteApi.getProviderEvent(eventId, providerId).pipe(
            finalize(() => {
                this.loading = false;
            }),
        ).subscribe({
            next: (event) => {
                this.event = event;
            },
            error: () => {
                this.event = null;
            },
        });
    }

    get diagnosticsEntries() {
        return this.event ? this.providerEventView.buildDiagnosticsEntries(this.event) : [];
    }

    get timelineActivities() {
        return this.event ? this.providerEventView.buildTimeline(this.event) : [];
    }
}
